import React, { FC, useContext } from 'react';
import { Option } from 'types/Option';
import { FILTER_TYPE } from 'types/Dog';
import { DataContext } from 'hooks/HeaderContext';

interface FilterBadgeProps { filter: Option }

const FilterBadge: FC<FilterBadgeProps> = ({ filter }) => {

    const {
        removeFilter,
    } = useContext(DataContext);

    const parseLabel = () => {
        if (!filter || !filter.label) return;
        if (filter.label.indexOf('(') !== -1) {
            let label = filter.label;
            return label.substring(0, label.indexOf('(') - 1);
        } else if (filter.type === FILTER_TYPE.INSTITUTION) {
            return filter.description;
        } else return filter.label;
    }

    return (
        <div className='filterTag me-2 py-1 mb-1'>
            <span className='filterTag-title'>
                {/* {filter.type === FILTER_TYPE.CUSTOM_VIEW &&
                    <i className='bi bi-geo-alt-fill me-2'></i>
                } */}
                {parseLabel()}
            </span>
            <button className='filterTag-removeBtn bg-transparent border-0 p-0 ms-1 d-flex align-items-center'
                onClick={() => removeFilter(filter, filter.type)}
            >
                <i className='bi bi-x fs-5 filter-remove-btn' />
            </button>
        </div >


    )
}

export default FilterBadge;




















